import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand from './CategoryCommand';

class CatalogsCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.CATALOGS,
    };
  }

  public getIcon(): IconName {
    return 'tree';
  }
}

export default CatalogsCommand;
